import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ChatPage from './pages/chat/ChatPage';
import MessagePage from './pages/chat/MessagePage';
/**
 * Sub-application on ibok which defines
 * our chat-context.
 * */
export var ChatRoutes = function () { return (React.createElement(Switch, null,
    React.createElement(Route, { exact: true, path: "/chat", component: ChatPage }),
    React.createElement(Route, { exact: true, path: "/chat/", component: ChatPage }),
    React.createElement(Route, { exact: true, path: "/chat/:slug", component: MessagePage }))); };
var ChatApp = function () { return (React.createElement(BrowserRouter, null,
    React.createElement(ChatRoutes, null))); };
export default ChatApp;
